/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */

/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */


require('./katex_loader');
require('./components/SearchOnPlatform.jsx');
require('./components/CustomSelectUniversity.jsx');
require('./components/CustomCheckbox.jsx');
require('./components/Hint.jsx');
require('./components/invite-friends.jsx');
require('./accordion')
require('./modal')

require('./course_tool/course_search')
require('./course_tool/course_video_list')
require('./course_tool/course_video_player')
require('./course_tool/course_menu_header')
require('./course_tool/course_notes')
require('./course_tool/course_questions')
require('./course_tool/course_question_header')
require('./course_tool/course_content_switch')

require('./masterclass_tool/masterclass_menu_header')
require('./masterclass_tool/masterclass_next_menu')
require('./masterclass_tool/masterclass_show')
require('./masterclass_tool/masterclass_search')

require('./privateclass_tool/privateclass_menu_header')
require('./privateclass_tool/privateclass_next_menu')
require('./privateclass_tool/privateclass_show')
require('./privateclass_tool/privateclass_search')
require('./privateclass_tool/master-private-classes-switch')
require('./privateclass_tool/privateclass_of_course')

require('./components/subscribe_payment_card.jsx')

require('./select_university/menu_universities')
require('./select_university/show_university')

require('./payment/subscribe')

require('./tool_layout/mobile_menu_helper')

// require('./worksheet_editor')

// tools
require('./tool/MatrixResult.jsx')
require('./tool/SetResult.jsx')

require('./tool/SingleNumberResult.jsx')
require('./tool/TestOptionsResult.jsx')

require('./content-course')

import amplitudClient from "./amplitude";
// admin


window.trackEvent = function (name, payload) {
    if(window.__DEV_ENV__ === 1) return;
    gtag('event', name, payload)
    amplitudClient.logEvent(name, payload)
}

function activateFirstMinutePlayer() {
    let vimeo = require('@vimeo/player').default

    let iframe = document.querySelector('iframe');
    let player = new vimeo(iframe);

    player.on('play', function() {
        console.log('Played the video');
        amplitudClient.logEvent('view_video_free', { slug })

    });

    player.getVideoTitle().then(function(title) {
        console.log('title:', title);
    });

    player.on('timeupdate', function(a) {
        if(a.seconds > 60) {
            player.pause()
            iframe.remove()
            document.getElementById('free-video').classList.remove('hidden')
        }
    })

}

window.playVideoVimeo = function (url, target){

    var ifrm = document.createElement('iframe');
    ifrm.setAttribute('width', '100%');
    ifrm.setAttribute('height', '360');
    ifrm.setAttribute('frameborder', '0');
    ifrm.setAttribute('allow', 'autoplay; fullscreen');
    ifrm.setAttribute('webkitallowfullscreen', 'true');
    ifrm.setAttribute('mozallowfullscreen', 'true');
    ifrm.setAttribute('allowfullscreen', 'true');
    ifrm.setAttribute('src', url);

    document.getElementById(target).replaceWith(ifrm)
}

window.playVideoVimeoByElement = function (url, target){

    var ifrm = document.createElement('iframe');
    ifrm.setAttribute('width', '100%');
    ifrm.setAttribute('height', '360');
    ifrm.setAttribute('frameborder', '0');
    ifrm.setAttribute('allow', 'autoplay; fullscreen');
    ifrm.setAttribute('webkitallowfullscreen', 'true');
    ifrm.setAttribute('mozallowfullscreen', 'true');
    ifrm.setAttribute('allowfullscreen', 'true');
    ifrm.setAttribute('src', url);

    target.replaceWith(ifrm)
}

if(document.getElementsByClassName('vimeo-player-placeholder')) {
    for(let element of document.getElementsByClassName('vimeo-player-placeholder')) {
        const src = element.dataset.src;


        window.playVideoVimeoByElement(src, element)
    }
}

function storeView(slug) {
    let vimeo = require('@vimeo/player').default

    let iframe = document.querySelector('iframe');
    let player = new vimeo(iframe);

    player.on('play', function() {
        // store view

        amplitudClient.logEvent('view_video', { slug })

        fetch(
            `/asignatura/register-view/${slug}`
        )
            .then(() => {
                console.log('store view');
            })
    });


}

window.storeLeasonView = storeView
window.activateFirstMinutePlayer = activateFirstMinutePlayer;


// worksheet tabs


window.tabMenuOnWorksheet = function(target, element) {
    console.log(target, element)

    for(let menu of document.getElementsByClassName('tab-menu-item')) {
        menu.classList.remove('active')
    }

    element.classList.add('active');

    for(let tab of document.getElementsByClassName('tabs-content')) {
        tab.classList.add('hidden')
    }

    document.getElementById(target).classList.remove('hidden');

    if(document.getElementById(target).dataset.script) {
        eval(document.getElementById(target).dataset.script)
    }

    // document.getElementsByClassName('tab-menu-item')
}



//handle utm parameters for laod url event

let paramsEvent = { path: location.pathname }

var urlParams = new URLSearchParams(window.location.search);
var keys = urlParams.keys();
for(let key of keys) {
    if(key.includes('utm')) {
        paramsEvent[key] = urlParams.get(key)
    }
}

window.trackEvent('LOAD_URL', paramsEvent);



// check  UTM and add it to the session
const utm = urlParams.get('utm_source');
console.log('checking utm')
if(utm) {
    console.log('UTM', utm)
    fetch('/ajax/add-utm', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            utm
        })
    }).then(r => console.log('registered utm'))
}


const maskInputCard = function(event, id) {
    console.log(event)
}

const maskInputs = document.getElementsByClassName('maskinput-card')
for(let k of maskInputs) {
    k.onkeyup = function(event) {
        let value = event.target.value

        const parts = value.split('')
        const result = []
        let counter = 0
        for(let i =0; i < parts.length; i++) {
            if(counter >= 16) break
            if(parts[i] == parseInt(parts[i])) {
                result.push(parts[i])
                if((counter + 1) % 4 === 0) result.push(' ')
                counter++
            }

        }

        k.value = result.join('').trim()
        console.log(event.target.value, result)
    }
}
window.maskInputCard = maskInputCard


const cdn = 'https://d2wl56ig1uoitb.cloudfront.net/images/';
const stars = document.getElementsByClassName('star-input')

for(let star of stars) {
        star.onclick= () => {
            const url = star.attributes['data-url'].value
            setSrcImageForChildren(star, `${cdn}star_fill_whiete.svg`)
            fetch(url)
                .then((a) => a.json())
                .then(result => {
                    const urlPic = `${cdn}${result.isFav ? 'star_fill.svg' : 'star.svg'}`
                    setSrcImageForChildren(star, urlPic)
                })
        }
}


const visiteds = document.getElementsByClassName('visited-input')

for(let visited of visiteds) {

        visited.onclick= () => {
            const url = visited.attributes['data-url'].value
            setSrcImageForChildren(visited, `${cdn}eye_fill_white.svg`)

            fetch(url)
                .then((a) => a.json())
                .then(result => {
                    const urlPic = `${cdn}${result.isVisited ? 'eye_fill.svg' : 'eye.svg'}`

                    setSrcImageForChildren(visited, urlPic)
                    isLoadingVisited = false
                })
        }
}

function setSrcImageForChildren(element, urlPic) {
    for(let c of element.children) {
        c.setAttribute('src', urlPic)
    }
}



function hideNotification(id) {
    const elm = document.getElementById(id)
    if(id) {
        elm.classList.add('hidden')
    }
}

window.hideNotification = hideNotification

function showNotification(id) {
    const elm = document.getElementById(id)
    if(id) {
        elm.classList.remove('hidden')
    }
}

window.showNotification = showNotification

const notificationHomeFreeMasterclass = document.getElementById('notification-free-masterclass')

if(notificationHomeFreeMasterclass)
{
    setTimeout(() => {
        showNotification('notification-free-masterclass')
    }, 2000)
}


const elementsButtonsHideWhileLoading = document.getElementsByClassName('hide-button-while-loading')
let isAlreadyLoading = false;
if(elementsButtonsHideWhileLoading) {
    for(let elm of elementsButtonsHideWhileLoading) {
        elm.addEventListener('click', (e) => {
            if(isAlreadyLoading) {
                e.preventDefault()
                return;
            }


            setTimeout(() => {
                const parent = elm.parentNode

                const isDescendantOfForm = function (e) {
                    let node = e.parentNode;
                    while (node) {
                        console.log(node.tagName)
                        if (node.tagName === 'FORM') {
                            return node;
                        }

                        // Traverse up to the parent
                        node = node.parentNode;
                    }

                    // Go up until the root but couldn't find the `parent`
                    return false;
                };

                // check if parent is form
                const $form = isDescendantOfForm(elm)
                if($form && !$form.checkValidity()) return

                isAlreadyLoading = true
                const newElement = document.createElement('div')
                newElement.classList.add('button')
                newElement.classList.add('button-big')
                newElement.classList.add('button-loading')
                newElement.innerText = 'Cargando ....'

                parent.replaceChild(newElement, elm)
            }, 100)

        })
    }
}
